<template>
  <section class="resources _pbm">
    <div container>
      <app-generate-report/>
      <div grid="row wrap">
        <div column="12">
          <div class="content-wrap _mbs _mts">
            <h2>Available Reports</h2>
          </div>
        </div>
        <template v-if="reports && reports.length != 0">
          <div column="xs-12 s-12 m-12" v-for="(report, i) in sortedReports" :key="i">
            <label>Posted: {{formatDate(report.requestDate || report.createDate)}}</label>
            <file-download
              @click="handleFileDownload({ reportId: report.reportId, type: 'EN', fileName: report.fileName })"
              :file-name="report.fileName"
              :file-downloading="reportIsDownloading(report.reportId)"
              :truncate-file-name="false"
            />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
  import DateHelper from '@mixins/DateHelper'
  import AppGenerateReport from './GenerateReport.vue'
  import FileDownload from '@organisms/FileDownload'
  import { sortReports } from '@/utils'
  import { useReporting } from '@composables/useReporting'

  export default {
    props: { reports: Array },
    components: {
      AppGenerateReport,
      FileDownload
    },
    mixins: [
      DateHelper
    ],
    computed: {
      sortedReports() {
        return sortReports(this.reports)
      }
    },
    setup() {
      const { handleFileDownload, reportIsDownloading } = useReporting()
      return {
        handleFileDownload,
        reportIsDownloading
      }
    }
  }
</script>
<style scoped>
section.reports {
  padding: 1rem 0;
}
</style>
